/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { List, ListItem } from '@mui/material';
import ArgosFlexbox from '../../../../../../../components/Containers/ArgosFlexbox';
import _ from 'lodash';

interface Props {
    onCloseDialog: Function;
    onConfirmUpdate: Function;
    rawCheckedNodes: any[];
    isUpdating: boolean;
}

/**
 * Warning dialog for updating configurations for multiple selected datasets.
 */
export const WarningDialog: React.FC<Props> = (props) => {
    return (
        <ArgosFlexbox vertical style={{ marginLeft: "30px", height: "100%" }}>
                You are about to overwrite configurations for the selected datasets: 
                <ArgosFlexbox style={{ width: "100%", maxHeight: "400px", overflow: "scroll", overflowY: "auto", overflowX: "hidden" }}>
                    <List sx={{ listStyleType: 'disc' }}>
                        { props.rawCheckedNodes.map((node: any, index: number) =>
                            (<ListItem key={index} sx={{ marginLeft: "20px", display: 'list-item' }}>
                                {node.name}
                            </ListItem>))
                        }  
                    </List>
                </ArgosFlexbox>
                This action cannot be undone. Are you sure you want to update?
        </ArgosFlexbox>
        )
}